import { V2CoachmarkTour } from '@abyss/web/ui/Coachmark';
import { Markdown } from '@abyss/web/ui/Markdown';
import React from 'react';

const CoachmarkStyling = {
  'abyss-coachmark-root': {
    width: '250px',
    marginTop: '8px',
    gap: '8px',
    zIndex: 10,
    color: '$coachmark-v2.color.text.paragraph.dark',

    '& p': {
      margin: 0,
    },
    '& p + p': {
      marginTop: '4px',
    },
  },
  'abyss-coachmark-title': {
    fontSize: '14px',
  },
  'abyss-coachmark-content-container': {
    display: 'none',
  },
};

type GuestPlanSelectionCoachmarkProps = {
  title: string;
  content: string;
  onClose: () => void;
};

export const GuestPlanSelectionCoachmark: React.FC<
  GuestPlanSelectionCoachmarkProps
> = ({ title, content, onClose }) => (
  <V2CoachmarkTour
    css={CoachmarkStyling}
    data-testid="guest-plan-selection-coachmark"
    onFinish={onClose}
    onSkip={onClose}
    startTour={true}
    steps={[
      {
        target: '#coachmark-anchor',
        title,
        description: '',
        extraContent: (
          <Markdown style={{ fontSize: '12px', color: 'inherit' }}>
            {content}
          </Markdown>
        ),
        position: 'bottom' as const,
      },
    ]}
    variant="gray"
  >
    <></>
  </V2CoachmarkTour>
);
